/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const HideCodeEditorOutputViewerWithOnlyQuizStepsSettingParser = 
/* #__PURE__ */ parsers.object([
    [
        'name',
        /* #__PURE__ */ parsers.exactly('HIDE_CODE_EDITOR_OUTPUT_VIEWER_WITH_ONLY_QUIZ_STEPS'),
    ],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class HideCodeEditorOutputViewerWithOnlyQuizStepsSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return HideCodeEditorOutputViewerWithOnlyQuizStepsSettingParser.decode(input).map(res => new HideCodeEditorOutputViewerWithOnlyQuizStepsSetting(res));
    }
    static unsafeDecode(input) {
        return HideCodeEditorOutputViewerWithOnlyQuizStepsSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return HideCodeEditorOutputViewerWithOnlyQuizStepsSettingParser.encode(data);
    }
    static schema() {
        return HideCodeEditorOutputViewerWithOnlyQuizStepsSettingParser.schema();
    }
}
